import {motion} from 'framer-motion';
import {divisions} from '../data/content';

export default function Academy({copy, lang}) {
  return (
    <section className="academy section" id="academy">
      <style>{`
        .academy-track {
          overflow: visible;
          padding: 1rem 0;
          scrollbar-width: none;
        }

        .academy-track::-webkit-scrollbar {
          display: none;
        }

        .academy-track .division-card {
          min-width: 0;
        }

        .academy-track .division-card p {
          margin-top: .8rem;
          color: #6f1717;
          font-size: .78rem;
          line-height: 1.65;
          letter-spacing: .06em;
          text-transform: none;
        }

        @media (max-width: 800px) {
          .academy-track {
            display: flex;
            flex-direction: column;
            gap: 0;
            padding: 0;
          }

          .academy-track .division-card {
            width: 100%;
            min-height: 0;
            height: auto;
            padding: 1.15rem 1.1rem;
            display: grid;
            grid-template-columns: 58px minmax(0,1fr) auto;
            grid-template-rows: auto auto;
            align-items: center;
            column-gap: 1rem;
            border-width: 1px 1px 0;
            cursor: default;
          }

          .academy-track .division-card:last-child {
            border-bottom-width: 1px;
          }

          .academy-track .division-card > b {
            grid-column: 1;
            grid-row: 1 / 3;
            font-size: 2rem;
            writing-mode: horizontal-tb;
          }

          .academy-track .division-card > h3 {
            grid-column: 2;
            grid-row: 1;
            margin: 0;
            font-size: 1.15rem;
          }

          .academy-track .division-card > p {
            grid-column: 2;
            grid-row: 2;
            margin-top: .25rem;
            font-size: .67rem;
          }

          .academy-track .division-card .seal {
            position: static;
            grid-column: 3;
            grid-row: 1 / 3;
            width: 30px;
            height: 30px;
            font-size: .7rem;
          }
        }
      `}</style>

      <div className="section-heading">
        <span>{copy.institutionEyebrow}</span>
        <h2>{copy.institutionTitle}</h2>
        <p>{copy.institutionBody}</p>
      </div>

      <div className="scroll-track academy-track">
        {divisions.map((division, index) => (
          <motion.article
            className="division-card"
            key={division.en}
            initial={{opacity: 0, y: 24}}
            whileInView={{opacity: 1, y: 0}}
            viewport={{once: true, amount: 0.2}}
            transition={{duration: 0.55, delay: index * 0.07}}
            whileHover={{y: -8, rotate: index % 2 ? 0.5 : -0.5}}
          >
            <span className="seal">{division.seal}</span>
            <b>{division.kanji}</b>
            <h3>{division.en}</h3>
            <p>{lang === 'zh-Hant' ? division.zh : division.role}</p>
            <div className="ink-line" />
          </motion.article>
        ))}
      </div>
    </section>
  );
}